var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDateDescending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.623 29.235c.213-.48.693-.799 1.119-.799h3.835v-6.731c0-.96.8-1.705 1.705-1.705.959 0 1.704.746 1.704 1.705v6.731h3.889c.532 0 1.012.32 1.172.799.213.48.106 1.012-.213 1.385l-5.54 5.966c-.533.532-1.385.532-1.865 0l-5.54-5.966c-.425-.373-.479-.906-.266-1.385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.571 4c.891 0 1.608.669 1.608 1.5V8h9.642V5.5c0-.831.717-1.5 1.608-1.5.89 0 1.607.669 1.607 1.5V8h2.678C32.078 8 34 9.794 34 12v6h-3.214v-2H7.214v16c0 .55.482 1 1.072 1H24v3H8.286C5.922 36 4 34.206 4 32V12c0-2.206 1.922-4 4.286-4h2.678V5.5c0-.831.717-1.5 1.607-1.5",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDateDescending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/date-descending.7540eacf259c00b8450c634ad30254c7.svg";